import { render, staticRenderFns } from "./contact-publisher.vue?vue&type=template&id=35293b02&"
import script from "./contact-publisher.vue?vue&type=script&lang=js&"
export * from "./contact-publisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports